<template>
    <RegistrationStepPage step-name="participantsDetails">
        <QuestionMain
            v-model="answers"
            :registrar-mode="false"
            :questions="eventData.questionsParticipants" />
    </RegistrationStepPage>
</template>

<script>
import QuestionMain from "@/components/pages/registration/questions/QuestionMain";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

export default {
    name: "ParticipantsDetails",
    components: {QuestionMain, RegistrationStepPage},
    mixins: [mainRegistrationMixin],
    computed: {
        answers: {
            get: function () {
                return this.registrationData.answers
            },
            set: function (value) {
                this.setRegistrationProp('answers', value)
            }
        }
    }
}
</script>

<style scoped>

</style>
